import { computed, Directive, input } from '@angular/core';
import type { ContextFamily } from '@quipex/shared/utils';

@Directive({
    selector: '[mat-list-item][qpx]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxNavItem {
    //#region Inputs
    public readonly interactive = input<boolean>(false);
    public readonly context = input<ContextFamily>();
    //#endregion

    //#region State
    protected readonly className = computed(() => {
        const _className = [];

        if (this.interactive()) {
            _className.push('mat-mdc-list-item-interactive');
        }

        const context = this.context();
        if (context) _className.push(context);

        return _className.join(' ');
    });
    //#endregion
}
